import LegacyAppShell from "#shared/app-shell/legacy-app-shell.tsx";

import AppRoutes from "./app-routes.tsx";
import {withStrings} from "./locales/app/load-strings.tsx";

const App = () => (
    <LegacyAppShell entrypoint="khanacademy">
        <AppRoutes />
    </LegacyAppShell>
);

export default withStrings()(App);
